export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verificación AML"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingrese una dirección y seleccione una blockchain — realizaremos un screening rápido."])}
}